import { Code } from 'constants/codes';

const ScheduleCalendarUrl = (
  DatabaseId: number, 
  CompanyId: number, 
  branchId: number,
  doctorList: string,
  startDate: string,
  endDate: string
): string => {
  return `${Code.Path.SERVER}custom/schedule?database_id=${DatabaseId}&company_id=${CompanyId}&branch_id=${branchId}&doctor_list=${doctorList}&start_date=${startDate}&end_date=${endDate}`;
};

export const APIUrl = {
    ScheduleCalendar: ScheduleCalendarUrl,
  }